<template>
    <v-sheet>
        <v-toolbar dense flat 
            color="secondary">
            <v-toolbar-title>{{$t("malfaction_report_summary")}}</v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
            <v-simple-table dense v-if="!loading">
                <thead>
                    <tr>
                        <th>{{$t("FAILURES")}}</th>
                        <th>{{$t("COUNT")}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(d, i) in data" :key="i" v-ripple @click="handleClick($event, d.id)">
                        <th>{{d.name}}</th>
                        <th>{{d.count}}</th>
                    </tr>
                </tbody>
            </v-simple-table>
            <div v-else class="pa-4">
                <v-progress-linear
                    class="my-4"
                    indeterminate
                    color="yellow darken-2"
                ></v-progress-linear>
                <div class="text-center">{{$t("please_wait")}}</div>
            </div>
    </v-sheet>
</template>

<script>
import { getMalfactionSummaryReport } from './../services/reports';
export default {
    name: "MalfactionsSummaryReport",
    props: {
        query: Object
    },
    data() {
        return {
            data: [],
            loading: false,
        }
    },
    watch: {
        query: {
            handler() {
                this.fetchData();
            }
        }
    },
    methods: {
        async fetchData() {
            this.loading = true;
            let resp = await getMalfactionSummaryReport();
            this.data = resp.data;
            this.loading = false;
        },
        handleClick(e, id) {
            this.$router.push({ path: "/reports/malfactions-report-by-truck-type", query: { malfaction_id: id }})
        }
    },
    created() {
        this.fetchData();
    }

}
</script>

<style>

</style>